import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatCurrency,
  formatDate,
  formatQuantity,
  replaceNulls,
  sizePerPageList,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

export const SpecialDiscTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  // const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      const newItem = replaceNulls(item);
      return {
        ...newItem,
        no: index + 1 + pageBefore,
      };
    });

    console.log(initData);
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              history.push(
                `/master/special-disc/edit/${row.special_discount_id}`
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",

      style: { minWidth: "70px" },
    },
    {
      text: "Discount",
      dataField: "special_discount_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "280px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <b>{row.special_discount_code}</b>
            </span>
            <br />
            <span>{row.special_discount_name}</span>
          </div>
        );
      },
    },

    {
      text: "Period",
      dataField: "start_at",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "300px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>{formatDate(row.start_at)}</span>-{" "}
            <span>{formatDate(row.end_at)}</span>
          </div>
        );
      },
    },
    {
      text: "Customer group",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "branch",
      dataField: "branch_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };
  return (
    <>
      <BootstrapTable
        remote
        striped
        noDataIndication="Data Not Found"
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={true}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
